module.exports = "/_next/static/images/0624815392af268412cdaf1e3009ddab-aboutus-hiring.jpg";